export default "__VITE_ASSET__DCdcO3bn__"